import { useEffect } from "react";
import { LOGO, OG_IMAGE_CAMPUSPATH } from "@/lib/constants";

/* Lightweight client-side SEO manager: updates title, description, canonical,
   favicon, Open Graph and Twitter tags per page. CampusPath and TestGuard are
   treated as two separate products with independent domains, favicons and
   social share images. */

function upsertMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SEO({
  title,
  description,
  canonical,
  image = OG_IMAGE_CAMPUSPATH,
  keywords,
  type = "website",
  favicon = LOGO,
}) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:image", image);
    if (canonical) upsertMeta("property", "og:url", canonical);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    upsertLink("canonical", canonical);
    upsertLink("icon", favicon);
    upsertLink("apple-touch-icon", favicon);
  }, [title, description, canonical, image, keywords, type, favicon]);

  return null;
}
